import { sound } from '@pixi/sound';

import { userSettingsStore } from '../../store/userSettingsStore';

import { PixiAssets } from '../../core/helpers/loadResources';

let pauseTimeOutId = null;

export const SoundTypes = {
  ReelStop: 'ReelStop',
  BackgroundMusic: 'gameBackgroundMusic',
  Scatter1Win: 'Scatter1Win',
  SevenSymbol: 'SevenSymbol',
  Scatter2Win: 'Scatter2Win',
  SpinButton: 'SpinButton',
  WildSymbol: 'WildSymbol',
  WildOpeningSound: 'WildOpeningSound',
  WildOpeningSound2: 'WildOpeningSound2',
  WildOpeningSound3: 'WildOpeningSound3',
  WinAccumulationSound: 'WinAccumulationSound',
  AmountIncrease: 'AmountIncrease',
  WinningLineSound: 'WinningLineSound',
  WinPopupBigWin: 'WinPopupBigWin',
  WinPopupEpicWin: 'WinPopupEpicWin',
  WinPopupMegaWin: 'WinPopupMegaWin',
  WinPopupSuperWin: 'WinPopupSuperWin',
  WinOneLineSound: 'WinOneLineSound',
  BigWinSound: 'BigWinSound',
  MegaWinSound: 'MegaWinSound',
  SuperWinSound: 'SuperWinSound',
  EpicWinSound: 'EpicWinSound',
  MaxWinSound: 'MaxWinSound',
  JackpotSymbolSound: 'JackpotSound',
  JackpotSymbol: 'JackpotSymbol',
  JackpotBackgroundMusic: 'JackpotBackgroundMusic',
  JackpotIlluminations: 'Illuminations',
  JackpotSceneTransition: 'SceneTransition',
  JackpotSuitAppearance: 'SuitAppearance',
  JackpotSuitTransfer: 'SuitTransfer',
  JackpotWinPopUp: 'WinPopUp',
  SceneShakeSound: 'SceneShakeSound',
  wheelSpinning: 'wheelSpinning',
  wheelWinPopup: 'wheelWinPopup',
  openWheel: 'openWheel',
  spinWheelButton: 'spinWheelButton',
};

export const soundOptions = [
  {
    path: 'sounds/spinWheelButton.mp3',
    name: SoundTypes.spinWheelButton,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/wheelSpinning.mp3',
    name: SoundTypes.wheelSpinning,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/wheelWinPopup.mp3',
    name: SoundTypes.wheelWinPopup,
    autoplay: false,
    loop: true,
    html5: true,
  },
  {
    path: 'sounds/openWheel.mp3',
    name: SoundTypes.openWheel,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/reelStop.mp3',
    name: SoundTypes.ReelStop,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/spinButton.mp3',
    name: SoundTypes.SpinButton,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/wildSymbol.mp3',
    name: SoundTypes.WildSymbol,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/bigWinSound.mp3',
    name: SoundTypes.BigWinSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/megaWinSound.mp3',
    name: SoundTypes.MegaWinSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/epicWinSound.mp3',
    name: SoundTypes.EpicWinSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/winOneLineSound.mp3',
    name: SoundTypes.WinOneLineSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/wildOpeningSound.mp3',
    name: SoundTypes.WildOpeningSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/wildOpeningSound2.mp3',
    name: SoundTypes.WildOpeningSound2,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/wildOpeningSound3.mp3',
    name: SoundTypes.WildOpeningSound3,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/superWinSound.mp3',
    name: SoundTypes.SuperWinSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/winningLineSound.mp3',
    name: SoundTypes.WinningLineSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/amountIncrease.mp3',
    name: SoundTypes.AmountIncrease,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/gameBackgroundMusic.mp3',
    name: SoundTypes.BackgroundMusic,
    autoplay: true,
    loop: true,
    html5: true,
  },
  {
    path: 'sounds/JackpotSymbolSound.mp3',
    name: SoundTypes.JackpotSymbolSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/jackpotBackgroundMusic.mp3',
    name: SoundTypes.JackpotBackgroundMusic,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/sceneTransition.mp3',
    name: SoundTypes.JackpotSceneTransition,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/suitAppearance.mp3',
    name: SoundTypes.JackpotSuitAppearance,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/winPopUp.mp3',
    name: SoundTypes.JackpotWinPopUp,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/scatter1Win.mp3',
    name: SoundTypes.Scatter1Win,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/scatter2Win.mp3',
    name: SoundTypes.Scatter2Win,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/sceneShakeSound.mp3',
    name: SoundTypes.SceneShakeSound,
    autoplay: false,
    html5: true,
  },
];

const SoundListNames = soundOptions.map((el) => el.name);

class SoundService {
  async play(name, config = {}) {
    if (userSettingsStore.isSoundOn) PixiAssets.get(name).play(config);
  }

  async stop(name) {
    PixiAssets.get(name).stop();
  }

  stopAll() {
    const SoundList = Object.values(PixiAssets.get(SoundListNames));
    SoundList.forEach((currentSound) => {
      currentSound.stop();
    });
  }

  stopAllSounds() {
    const SoundList = Object.values(PixiAssets.get(SoundListNames));
    SoundList.forEach((currentSound) => {
      if (!currentSound.options.url.includes('Music')) {
        currentSound.stop();
      }
    });
  }

  playMusic() {
    if (userSettingsStore.isSoundOn) {
      this.play(SoundTypes.BackgroundMusic, { loop: true });
    }
  }

  pauseSounds() {
    clearTimeout(pauseTimeOutId);
    sound.pauseAll();
  }

  resumeSounds() {
    clearTimeout(pauseTimeOutId);
    pauseTimeOutId = setTimeout(() => {
      sound.resume(SoundTypes.BackgroundMusic);
    }, 2000);
  }
}

const soundService = new SoundService();

export { SoundTypes as soundTypes, soundService };
